(() => {
  if (customElements.get('akaari-product-accordions')) return;

  class AkaariProductAccordions extends HTMLElement {
    connectedCallback() {
      this.variantListener ??= this.onVariantUpdate.bind(this);
      document.addEventListener('variant:update', this.variantListener);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.variantListener);
    }

    onVariantUpdate(event) {
      // A quick-add dialog must not update a separate product-page instance.
      const scope = this.closest('quick-add-dialog, .shopify-section');
      if (event.target instanceof Element && event.target.closest('quick-add-dialog, .shopify-section') !== scope) return;
      const productId = String(event?.detail?.data?.productId || '');
      if (productId && productId !== String(this.dataset.productId || '')) return;

      const html = event?.detail?.data?.html;
      if (!html) return;

      const blockId = this.dataset.blockId;
      const selector = blockId
        ? `akaari-product-accordions[data-block-id="${CSS.escape(blockId)}"]`
        : 'akaari-product-accordions';
      const fresh = html.querySelector(selector);
      if (!fresh) return;

      this.dataset.productId = fresh.dataset.productId || this.dataset.productId || '';

      const openState = new Map(Array.from(this.querySelectorAll('details[data-accordion-key]'))
        .map((detail) => [detail.dataset.accordionKey, detail.open]));

      this.innerHTML = fresh.innerHTML;
      if (!event.detail.resource) this.querySelector('[data-accordion-key="price-breakdown"]')?.remove();

      this.querySelectorAll('details[data-accordion-key]').forEach((detail) => {
        if (openState.has(detail.dataset.accordionKey)) detail.open = openState.get(detail.dataset.accordionKey);
      });
    }
  }

  customElements.define('akaari-product-accordions', AkaariProductAccordions);
})();
